import React, { useState } from 'react'
import model_array from '../modules/model_array'
import { NavLink, withRouter } from 'react-router-dom'
import Icon from './Icon'
import Confirmation from './Confirmation'
import { appContext } from '../App'
import useData from '../hooks/useData'
import { Navbar, NavbarToggler, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'

const visible_model_array = model_array.filter((model) => model.visible)
const Header = (props) => {
    const [options_expanded, setOptionsExpanded] = useState(false)
    const [display_logout_modal, setDisplayLogOut] = useState(false)

    // const AppContext = useContext(appContext)
    // const { state: AppStateContext } = useContext(appStateContext)
    // useEffect(() => { AppContext.fetchUnavailable() }, [])
    // const { data: unavailable_links } = useData('provider/amazon/unavailable_links?scope=list')
    const siteArray = useData('site')

    const setOptionsExpandedState = () => setOptionsExpanded(!options_expanded)
    return (
        <appContext.Consumer>
            {(app) => (
                <div id="main-nav" className={props.className || undefined}>
                    <Navbar color="dark" dark expand="md">
                        <div className="container">
                            <NavLink to="/" className="navbar-brand">
                                PerfectSense
                            </NavLink>
                            <NavbarToggler onClick={setOptionsExpandedState} />
                            <Nav className="ml-auto" navbar>
                                <UncontrolledDropdown nav inNavbar className="alt-visible">
                                    <DropdownToggle nav caret>
                                        Trash
                                    </DropdownToggle>
                                    <DropdownMenu right className="bg-dark text-light">
                                        {visible_model_array.map((model) => (
                                            <DropdownItem key={`nav-list-${model.name}`}>
                                                <NavLink to={`/${model.name}/list?active=0`} className="nav-link">
                                                    {model.name}
                                                </NavLink>
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                                <NavItem>
                                    <NavLink to="/clicks" className="nav-link">
                                        Clicks
                                    </NavLink>
                                </NavItem>
                                {/* <NavItem>
                                    <NavLink to="/unavailable" className="nav-link">
                                        Unavailable {(unavailable_links && <span className="badge badge-secondary">{unavailable_links.length}</span>) || null}
                                    </NavLink>
                                </NavItem> */}

                                {/* <NavItem>
                                    <NavLink to={`/provider/amazon/commissions?average_min=1000`} className="nav-link">
                                        Commissions
                                    </NavLink>
                                </NavItem> */}
                                <NavItem>
                                    <NavLink to="/competitor/list" className="nav-link">
                                        Competition
                                    </NavLink>
                                </NavItem>
                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret color="dark">
                                        SEO
                                    </DropdownToggle>
                                    {(siteArray.data && (
                                        <DropdownMenu right className="bg-dark text-light">
                                            {siteArray.data
                                                ?.sort((a, b) => a.label.localeCompare(b.label))
                                                .map((site) => (
                                                    <DropdownItem key={`nav-list-${site.id}-search-console`}>
                                                        <NavLink to={`/site/view/${site.id}/search-console`} className="nav-link">
                                                            {site.label}
                                                        </NavLink>
                                                    </DropdownItem>
                                                ))}
                                        </DropdownMenu>
                                    )) ||
                                        null}
                                </UncontrolledDropdown>

                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret color="dark">
                                        Resources
                                    </DropdownToggle>
                                    <DropdownMenu right className="bg-dark text-light">
                                        <DropdownItem>
                                            <NavLink to="/inspect" className="nav-link">
                                                Web
                                            </NavLink>
                                        </DropdownItem>
                                        <DropdownItem>
                                            <NavLink to="/resources" className="nav-link">
                                                Google
                                            </NavLink>
                                        </DropdownItem>
                                        <DropdownItem>
                                            <NavLink to={`/provider/amazon`} className="nav-link">
                                                Amazon
                                            </NavLink>
                                        </DropdownItem>
                                        {(props.alt && (
                                            <DropdownItem>
                                                <NavLink to={`/provider/amazon/crawl`} className="nav-link">
                                                    Crawl
                                                </NavLink>
                                            </DropdownItem>
                                        )) ||
                                            null}
                                    </DropdownMenu>
                                </UncontrolledDropdown>

                                {/* <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret color="dark">
                                        Articles
                                    </DropdownToggle>
                                    {(siteArray.data && (
                                        <DropdownMenu right className="bg-dark text-light">
                                            {siteArray.data
                                                .sort((a, b) => a.label.localeCompare(b.label))
                                                .map((site) => (
                                                    <DropdownItem key={`nav-list-${site.id}`}>
                                                        <NavLink to={`/site/view/${site.id}`} className="nav-link">
                                                            {site.label}
                                                        </NavLink>
                                                    </DropdownItem>
                                                ))}
                                        </DropdownMenu>
                                    )) ||
                                        null}
                                </UncontrolledDropdown> */}
                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret color="dark">
                                        List
                                    </DropdownToggle>
                                    <DropdownMenu right className="bg-dark text-light">
                                        {visible_model_array.map((model) => (
                                            <DropdownItem key={`nav-list-${model.name}`}>
                                                <NavLink to={`/${model.name}/list?active=1`} className="nav-link">
                                                    All {model.name.replace('_', ' ')}s
                                                </NavLink>
                                            </DropdownItem>
                                        ))}
                                        <DropdownItem key={`nav-list-checks`}>
                                            <NavLink to={`/checks`} className="nav-link">
                                                Checks
                                            </NavLink>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                                <NavItem>
                                    <div className="nav-link pointer" onClick={() => setDisplayLogOut(true)}>
                                        <Icon name="log-out" />
                                    </div>
                                </NavItem>
                            </Nav>
                        </div>
                    </Navbar>
                    <Confirmation
                        isOpen={display_logout_modal}
                        toggle={() => setDisplayLogOut(false)}
                        confirm={() => app.logOut()}
                        title={'Log out'}
                        text={'Are you sure you want to log out?'}
                    />
                </div>
            )}
        </appContext.Consumer>
    )
}

export default withRouter(Header)
